import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule, TooltipModule } from 'ngx-bootstrap';

import { FeedbackExecutionComponent } from './feedback-execution.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { InfoIconModule } from 'src/app/shared/info-icon/info-icon.module';
import { CandidateCardIconsModule } from 'src/app/shared/candidate-card-icons/candidate-card-icons.module';
import { CandidateAdditionalDetailsModule } from 'src/app/shared/candidate-additional-details/candidate-additional-details.module';
import { BulkFormalizeModule } from 'src/app/shared/ai-assistant/bulk-formalize/bulk-formalize.module';
import { ExternalNotesModule } from 'src/app/shared/external-notes/external-notes.module';

// Split out of FeedbackExecutionModule so app-feedback-execution can be depended on
// without pulling in FeedbackExecutionActionsModalComponent, which itself depends on
// JobMatchProfileOnConferenceModule (22b-6 step 8) — importing the full
// FeedbackExecutionModule from there would be circular.
@NgModule({
    declarations: [
        FeedbackExecutionComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        PipesModule,
        InfoIconModule,
        CandidateCardIconsModule,
        CandidateAdditionalDetailsModule,
        BulkFormalizeModule,
        ExternalNotesModule
    ],
    exports: [
        FeedbackExecutionComponent
    ],
    entryComponents: [
        FeedbackExecutionComponent
    ]
})
export class FeedbackExecutionComponentModule { }
